import { DateTime } from 'luxon';

export const getTaskDueDateFontColor = (date?: string) => {
  if (!date) {
    return undefined;
  }
  const workingDate = DateTime.fromISO(date).toJSDate();
  const today = DateTime.now().toJSDate();
  const tomorrow = DateTime.now().plus({ days: 1 }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toJSDate();

  switch (true) {
    case workingDate < today:
      return 'red400';
    case workingDate > today && workingDate < tomorrow:
      return 'green400';
    default:
      return undefined;
  }
};
